import Axios from "axios";
import store from "../store";

window.axios = Axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content

window._axios = Axios.create({
    headers: {
        'X-Requested-With' : 'XMLHttpRequest',
        'X-CSRF-TOKEN' : document.head.querySelector('meta[name="csrf-token"]').content
    }
});

window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        store.dispatch('logoutUser');
    }

    if (error.response.status === 403) {
        store.commit('activateSnackbar');
    }

    return Promise.reject(error.response);
})

window._axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error.response);
})
